const testimonialNav = document.querySelectorAll('.testimonials-nav button');
const testimonialTabs = document.querySelectorAll('.testimonials-grid');

testimonialNav.forEach((button, index) => {
  button.addEventListener('click', () => {
    testimonialNav.forEach((button, buttonIndex) => {
      button.classList.remove('tw-border-b');
      if(buttonIndex === index) {
        button.classList.add('tw-border-b');
      }
    });
    testimonialTabs.forEach((tab, tabIndex) => {
      tab.classList.add('tw-hidden');
      if(tabIndex === index) {
        tab.classList.remove('tw-hidden');
      }
    });
  });
});